import React from 'react';
import { t } from '../../../../modules/infra/i18n';

import { canUserModifyWaitingList } from '../../../common/helpers/users';
import Switch from '../../../common/checkboxSwitch';
import RangeSelect from '../../../common/rangeSelect';
import * as commonShapes from '../../../common/shapes';


const WaitingList = ({ handleSubmit, submitting, pristine, valid, permissions }) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <form onSubmit={handleSubmit}>
          <fieldset disabled={!canUserModifyWaitingList(permissions) || submitting}>
            <div className="u-ph">
              <div className="layout">
                <div className="layout__item">
                  <Switch name="enabled" label={t('settings:waiting_list.enabled_label')} />
                </div>
                <div className="layout__item">
                  <div className="c-label-new">{t('settings:waiting_list.threshold_label')}</div>
                  <RangeSelect
                    className="c-select c-select--small u-mr--"
                    start={1}
                    end={25}
                    increment={1}
                    name="waitingListThreshold"
                  />{ }{t('settings:waiting_list.hours_unit')}
                </div>
              </div>
            </div>
            <div className="c-separator u-mv" />
            <div className="u-text-right">
              <button
                type="submit"
                className="c-btn u-width-120"
                disabled={pristine || !valid}
              >
                <span className="c-btn__text">{t('settings:waiting_list.save_button')}</span>
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
);
WaitingList.propTypes = {
  handleSubmit: commonShapes.handler.isRequired,
  submitting: commonShapes.flag.isRequired,
  pristine: commonShapes.flag.isRequired,
  valid: commonShapes.flag.isRequired,
  permissions: commonShapes.permissions.isRequired,
};

export default WaitingList;
